import './contacts-data.scss';

import { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Input, MaskedInput } from '@/components/Shared/ui';

import { CreateTabContext } from '../../LlpOrder';
import type { CreateLeasingProps } from '../../widgets/create-tab';

const ContactsData: React.FC = () => {
  const { isFieldsFrozen } = useContext(CreateTabContext);

  const {
    control,
    formState: { errors }
  } = useFormContext<CreateLeasingProps>();

  return (
    <div className="contacts-data">
      <Controller
        control={control}
        name="fullName"
        rules={{
          required: 'Пожалуйста, введите данные',
          minLength: { value: 1, message: 'Пожалуйста, введите данные' }
        }}
        render={({ field }) => (
          <Input
            {...field}
            label="ФИО"
            error={errors.fullName?.message}
            isRequired
            isFrozen={isFieldsFrozen}
          />
        )}
      />
      <Controller
        control={control}
        name="phone"
        rules={{
          required: 'Пожалуйста, введите данные',
          minLength: {
            value: '+7 ___ ___ __ __'.length,
            message: 'Невалидный номер телефона'
          }
        }}
        render={({ field }) => (
          <MaskedInput
            {...field}
            type="tel"
            label="Контактный телефон"
            error={errors.phone?.message}
            mask="+7 ___ ___ __ __"
            replacement={{ _: /\d/ }}
            isRequired
            isFrozen={isFieldsFrozen}
          />
        )}
      />
      <Controller
        control={control}
        name="email"
        rules={{
          required: 'Пожалуйста, введите данные',
          minLength: { value: 1, message: 'Пожалуйста, введите данные' },
          pattern: {
            value: /.+@.+\..+/,
            message: 'Невалидный email адрес'
          }
        }}
        render={({ field }) => (
          <Input
            {...field}
            type="email"
            label="Email"
            error={errors.email?.message}
            isRequired
            isFrozen={isFieldsFrozen}
          />
        )}
      />
    </div>
  );
};

export default ContactsData;
